import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { connectRequest } from '../../../utils/query';
import { requestAsync } from '../../../queries/actions';
import { getPaymentMethodRequest, updateProfilePaymentMethodRequest } from '../../../queries/payment';
import {
  selectBootstrapConfig,
  selectSubscriberConfig,
  selectSubscriptionList
} from '../../../queries/selectors/bootstrap';
import { selectCurrentContentId, selectCurrentContent } from '../../../queries/selectors/contents';
import {
  selectPaymentConfig,
  selectPaymentMethods,
  selectCurrentPaymentMethod,
  selectCurrentContentPPVId,
  selectShouldChangeFavoritePaymentMethod
} from '../../../queries/selectors/payment';
import { selectCountryCode } from '../../../queries/selectors/subscriptions';
import { selectShoppingCartConfig } from '../../../queries/selectors/shoppingCart';
import { sendTransactionRequest, updatePlanSubscription, upgradeAddOnSubscriptions } from '../../../queries/subscription';
import { selectClient, selectCountry, selectSearchObj } from '../../../global-selectors';
import { selectDeviceCountry, selectUserData } from '../../../queries/selectors/user';
import { getPaymentMethodsByUser, NewPaymenthMethodsToUser } from '../../../queries/paymentMethods';
import { getCustomerBySubscriber } from '../../../queries/customer';
import { setShouldChangeFavoritePaymentMethod } from '../../../queries/actions/payment';

const mapStateToProps = (state) => {
  return {
    contentId: selectCurrentContentId(state),
    paymentConfig: selectPaymentConfig(state),
    deviceCountry: selectDeviceCountry(state),
    config: selectBootstrapConfig(state),
    userData: selectUserData(state),
    client: selectClient(state),
    content: selectCurrentContent(state),
    countryCode: selectCountryCode(state),
    country: selectCountry(state),
    currentContentPPVId: selectCurrentContentPPVId(state),
    subscriberConfig: selectSubscriberConfig(state),
    paymentMethods: selectPaymentMethods(state),
    currentPaymentMethod: selectCurrentPaymentMethod(state),
    shoppingCart: selectShoppingCartConfig(state),
    subscriptions: selectSubscriptionList(state),
    searchParams: selectSearchObj(state),
    newPaymentforceToChangeToFavorite: selectShouldChangeFavoritePaymentMethod(state)
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  updateProfilePaymentMethod: (data) => requestAsync(updateProfilePaymentMethodRequest, data),
  sendTransaction: (data) => requestAsync(sendTransactionRequest, data),
  setShouldChangeFavoritePaymentMethod: payload => dispatch(setShouldChangeFavoritePaymentMethod(payload)),
  upgradeAddOnSubscriptions: (data) => requestAsync(upgradeAddOnSubscriptions, data),
  updatePlanSubscription: (data) => requestAsync(updatePlanSubscription, data),
  newPaymentMethod: (data) => requestAsync(NewPaymenthMethodsToUser, data),
  getPaymentMethodsByUser: (data) => requestAsync(getPaymentMethodsByUser, data),
  getCustomerBySubscriber: (data) => requestAsync(getCustomerBySubscriber, data),
}, dispatch);

const mapPropsToConfigs = (props) => [
  getPaymentMethodRequest(props),
];

const enhancer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  connectRequest(mapPropsToConfigs)
);

export default enhancer;
